import { BaseWidgetRenderer } from './base-widget-renderer';
import { TextWidgetJsonData, WidgetRenderOptions } from '../../models/element-types';

export class TextWidgetRenderer extends BaseWidgetRenderer<TextWidgetJsonData> {
    protected override get defaultData(): TextWidgetJsonData {
        return {
            id: '',
            type: 'text',
            content: ''
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderContent(widgetJsonData: TextWidgetJsonData, options: WidgetRenderOptions): HTMLElement {
        const content = document.createElement('div');
        content.classList.add('element-content');

        const textElement = document.createElement('div');
        textElement.dataset['inlineInject'] = '';
        textElement.classList.add('ck-content');

        if (widgetJsonData.content) {
            textElement.innerHTML = widgetJsonData.content;
        }

        content.appendChild(textElement);
        return content;
    }
}
